import React from 'react';
import {
    RichCell,
    Button, SplitLayout, SplitCol, Div
} from '@vkontakte/vkui';
import {
    AdaptivityContext, getEquipmentTypes
} from "../../assets/constants";


import {
    Icon20AddCircleFillGreen,
    Icon20EditCircleFillBlue,
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import BaseList from "../../components/BaseList";
import EquipmentApi from "../../api/references/equipment";




class EquipmentList extends BaseList {





    getItems = (mainSearch = '', append = false, page = 1) => {
        clearInterval(this.searchInterval);

        console.log(this.state)

        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == '') {
            mainSearch = this.state.mainSearch ?? ''
        }


        EquipmentApi.getList(
            {
                search: mainSearch,
                page,
                epp: AdaptivityContext.isMobile ? 10 : 20
            }
        ).then(response => {

            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })


    }

    getObjectLink = (item) => {
        if (!item || item.id == null || item.id <= 0) {
            return null;
        }
        return {type: 'equipment', id: item.id};
    }

    createItem = () => {
        window.postMessage({
            type: 'setCurrentEquipment',
            value: {id: -1}
        })
    }
    getItem = (item) => {
        EquipmentApi.getOne(item.id).then(response => {
            const {data} = response

            if (data.id) {
                window.postMessage({type: 'setCurrentEquipment', value: data})
            }
        })
    }

    renderToolbar = () => {
        return <div
            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout>
                <SplitCol style={{justifyContent: "flex-start"}}>
                    <Div>
                        <Button mode="outline"
                                onClick={() => this.createItem()}><Icon20AddCircleFillGreen/></Button>

                    </Div>
                </SplitCol>

                <SplitCol>
                    <Div>
                                <span className="all-docs"
                                      id="cnt_items">Всего элементов: {this.state.cnt_items}</span>


                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>
    }

    constructor() {
        super();
        this.types = getEquipmentTypes()
    }

    renderRow = (item, index) => {

        return <RichCell multiline subhead={
                <div>
                    <span>{item.stand_id ? `Стенд ${item.stand.title}` : ''}</span>
                    &nbsp;&nbsp;&nbsp;
                    <b>{item.type_id ? `Тип ${this.types[item.type_id]}` : ''}</b>
                </div>
                }
                         caption={
                                 <div>
                                     <span>{item.collection_id ? `Коллекция ${item.collection.title}` : ''}</span>
                                     &nbsp;&nbsp;&nbsp;
                                     <b>{item.is_competitor ? `Конкурент` : ''}</b>
                                 </div>
                             }

                         afterCaption={<div style={{display: "flex", flexDirection: "column"}}>
                             <Button mode="outline" size="m"
                                     onClick={() => this.getItem(item)}><Icon20EditCircleFillBlue/></Button>
                         </div>
                         }
        >
            {item.title}
        </RichCell>
    }

}

export default EquipmentList